module.exports = __webpack_public_path__ + "static/media/Logo.e6ff7d3e.svg";